<template>
  <p>
    Sorry, We couldn't find that page!
  </p>
</template>

<script>
export default {
  name: 'notFound'
};
</script>

<style scoped>
p {
    font-weight: bold;
    font-size: 50px;
    text-align: center;
    color: #f10b0b;
}
</style>



// WEBPACK FOOTER //
// src/components/error-pages/notFound.vue